<template>
    <div class="LegendBar">
        <LegendTag
            v-for="l in legend"
            :key="l.label"
            class="LegendBar__tag"
            :name="l.name"
            :color="l.color"
        />
    </div>
</template>
<script>
import LegendTag from './LegendTag.vue';
export default {
    name: 'LegendBar',
    components: {
        LegendTag
    },
    props: {
        legend: {
            type: Array,
            required: true
        }
    }
};
</script>
<style lang="scss">
    .LegendBar {
        display: flex;
        align-items: center;
        &__tag {
            margin-right: 1rem;
        }
    }
</style>
